import React from 'react'
import {connect} from 'react-redux'
import { addActionToButton } from "../actions"
import {SidebarItem} from "../styled-components/components"
import styled from 'styled-components'
import {tooltips} from "../constants"

const StyledAction = styled(SidebarItem)
`
    background:#373535;
    margin:2px 0px;
    cursor:pointer;
    font-weight:300;
    position:relative;

    &:after{
    content:"+";
    display:block;
    position:absolute;
    right:10px;
    top:9px;
    font-size:20px;
    font-weight:bold;
    font-family:'Roboto', sans-serif;
    }
    &:hover{
        color:white;
        background:#222222;
    }
`
const Action = ({action, actionName, preset, buttonID, dispatch}) => {
    return (<StyledAction data-tip={tooltips.Action} onClick={()=>(dispatch(addActionToButton(preset, buttonID, actionName, action)))}>
        {actionName}
    </StyledAction>)
}

function mapStateToProps(state){
    return{
        buttonID : state.buttons,
        preset : state.preset
    }
}

export default connect(
    mapStateToProps
)(Action)


